import { render } from "./MarketplacePage.vue?vue&type=template&id=b5f06a50&scoped=true"
import script from "./MarketplacePage.vue?vue&type=script&lang=js"
export * from "./MarketplacePage.vue?vue&type=script&lang=js"

import "./MarketplacePage.vue?vue&type=style&index=0&id=b5f06a50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f06a50"]])

export default __exports__